module.exports = __webpack_public_path__ + "img/tabbed-search-filter-mazda.448f899c.png";